<template>
    <img v-if="type == 'white'" src="/img/cms/logo-white.png" />
    <img v-else-if="type == 'black' " src="/img/cms/logo-black.png" />
    <img v-else src="/img/cms/logo-color.png" />
</template>

<script>

export default {
    props: {
        type: {
            type: String,
            default: null,
        }
    }
}
</script>
